// Global wait function (safe loader for jQuery)
function waitFor(conditionFn, callback, checkInterval = 25, timeout = 6000) {
  const start = Date.now();
  (function check() {
    if (conditionFn()) return callback();
    if (Date.now() - start >= timeout) {
      console.warn("waitFor(): timeout waiting for condition");
      return;
    }
    setTimeout(check, checkInterval);
  })();
}

// Main script (runs ONLY when jQuery is ready)
waitFor(() => window.jQuery && window.$, function () {
  function r(f) {
    /in/.test(document.readyState) ? setTimeout(() => r(f), 9) : f();
  }

  r(function () {
    // -----------------------------------------
    // Update captions
    // -----------------------------------------
    const updateCaption = (selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.textContent = "Usually ready in 2-4 Weeks for bulky items";
      });
    };

    updateCaption(".pickup-availability-info .caption");
    updateCaption(".pickup-availability-list .caption-large");
    updateCaption("._1x52f9si");

    // -----------------------------------------
    // Subheader scroll behavior
    // -----------------------------------------
    const subheader = document.querySelector(".subheader-ext");
    let subheaderRaf = null;
    window.addEventListener(
      "scroll",
      () => {
        if (!subheader || subheaderRaf) return;
        subheaderRaf = requestAnimationFrame(() => {
          subheaderRaf = null;
          window.scrollY > 350
            ? subheader.classList.remove("showing")
            : subheader.classList.add("showing");
        });
      },
      { passive: true }
    );

    // -----------------------------------------
    // Hamburger / PatioForge mobile nav
    // -----------------------------------------
    const element = document.getElementById("che-hamburger-menu");
    const overlay = document.getElementById("che-menu-overlay");
    const closeBtn = document.getElementById("fp-mobile-nav-close");
    const body = document.body;

    if (element && overlay) {
      const setMenuOpen = (isActive) => {
        element.classList.toggle("active", isActive);
        overlay.classList.toggle("active", isActive);
        overlay.classList.toggle("remove", !isActive);
        body.classList.toggle("noscroll", isActive);
        overlay.setAttribute("aria-hidden", isActive ? "false" : "true");
        element.setAttribute("aria-expanded", isActive ? "true" : "false");
        element.setAttribute("aria-label", isActive ? "Close menu" : "Open menu");

        if (isActive) {
          const focusTarget = closeBtn || overlay.querySelector("a, button");
          if (focusTarget) {
            try {
              focusTarget.focus({ preventScroll: true });
            } catch (err) {
              /* ignore */
            }
          }
          if (typeof trapFocus === "function") {
            trapFocus(overlay, focusTarget || overlay);
          }
        } else {
          if (typeof removeTrapFocus === "function") {
            removeTrapFocus(element);
          }
          try {
            element.focus({ preventScroll: true });
          } catch (err) {
            /* ignore */
          }
        }
      };

      element.setAttribute("role", "button");
      element.setAttribute("aria-controls", "che-menu-overlay");
      element.setAttribute("aria-expanded", "false");
      element.setAttribute("aria-label", "Open menu");
      if (!element.hasAttribute("tabindex")) element.setAttribute("tabindex", "0");

      element.onclick = (e) => {
        e.preventDefault();
        setMenuOpen(!element.classList.contains("active"));
      };

      element.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setMenuOpen(!element.classList.contains("active"));
        }
      });

      if (closeBtn) {
        closeBtn.onclick = (e) => {
          e.preventDefault();
          setMenuOpen(false);
        };
      }

      overlay.addEventListener("click", (e) => {
        if (e.target === overlay) setMenuOpen(false);
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && element.classList.contains("active")) {
          setMenuOpen(false);
        }
      });
    }

    // -----------------------------------------
    // Show hidden sections
    // -----------------------------------------
    [
      "apps-che-category-slider-wrapper",
      "che-product-slider-fridges",
      "che-product-slider-outdoor-wrapper",
      "che-home-slider-wrapper",
      "che-mouse-over-slider-container",
      "che-simple-image-banner",
      "gazebo-product-slider-wrapper",
      "che-product-slider-signature-wrapper",
    ].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = "block";
    });

    // -----------------------------------------
    // Mouse-over background preview
    // -----------------------------------------
    const collection = document.getElementsByClassName(
      "che-mouse-over-src-slider"
    );
    if (collection.length > 0) {
      const dataSrc = collection[0].getAttribute("data-src");
      const mouseOverMainElement = document.getElementById(
        "che-mouse-over-slider"
      );
      if (mouseOverMainElement && dataSrc) {
        mouseOverMainElement.style.backgroundImage = `url('${dataSrc}')`;
        mouseOverMainElement.style.backgroundPosition = "center";
        mouseOverMainElement.style.backgroundRepeat = "no-repeat";
        mouseOverMainElement.style.backgroundSize = "cover";
      }
    }

    // Tiny Slider removed from theme — skip tns init; Splide/native sliders handle carousels.

    // -----------------------------------------
    // Alphabet container (safe)
    // -----------------------------------------
    const cac = document.getElementById("che-alphabet-container");
    if (cac) {
      const alphabet = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      let li = "";
      alphabet.forEach((letter) => {
        const safe = letter.replace(/[^A-Z#]/g, "");
        li +=
          '<li class="' +
          safe +
          '"><span data-letter="' +
          safe +
          '">' +
          safe +
          '</span><div class="che-aphabet-list-container" id="che-aphabet-list-container-' +
          safe +
          '"></div></li>';
      });
      cac.innerHTML = '<ul class="che-alphabet-list">' + li + "</ul>";
      cac.addEventListener("mouseover", (e) => {
        const span = e.target.closest("[data-letter]");
        if (!span || typeof window.getData !== "function") return;
        window.getData(span.getAttribute("data-letter"));
      });
    }
  });

  // -----------------------------------------
  // Hide widget if present
  // -----------------------------------------
  document.addEventListener("DOMContentLoaded", () => {
    const widget = document.getElementById("fc_frame");
    if (widget) widget.style.display = "none";

    new MutationObserver(() => {
      const dynamicWidget = document.getElementById("fc_frame");
      if (dynamicWidget) dynamicWidget.style.display = "none";
    }).observe(document.body, { childList: true, subtree: true });
  });
});
